import React from 'react';
import { useContact } from '../../context/ContactContext';
import { useRingtone } from '../../hooks/useRingtone';
import '../../styles/incoming-v3.css';

// Custom incoming-call screen: replaces the dependency on the hidden native CCP
// tab for answering. Streams' own ring (disableRingtone:false) plays alongside.
//
// #113 (2026-09-22): rendered INSIDE the shell (header, rails, this card in
// the centre) on the frozen v3 spec's incoming card. What the console knows
// at ring time is the caller's number and the tenant (ContactContext's
// CONTACT_INCOMING), so that is what the card says. The spec's CRM match,
// open ticket, "AI sentiment at handover", wait/ring timers, and the
// "HANDED OVER BY AI" label have no source at this point and are omitted
// (vault #216: placeholder or omit). Accept, Decline and the ringtone are
// unchanged.
export default function IncomingCall() {
  const { incomingContact, handleAccept, handleDecline, softphoneError } = useContact();
  // Incident 2026-09-14 fix 2: if the softphone reported a problem in the
  // last two minutes, say so right under the buttons — an Accept that
  // cannot bring up media otherwise looks like it did nothing.
  const recentError = softphoneError && Date.now() - softphoneError.at < 120_000 ? softphoneError : null;
  useRingtone(!!incomingContact);

  if (!incomingContact) return null;
  const { caller, tenant } = incomingContact;

  return (
    <main className="centre-panel incoming-v3-screen">
      <div className="incoming-card" role="region" aria-label="Incoming call">
        <div className="incoming-head">
          <span className="incoming-ring" aria-hidden="true">
            <span className="incoming-ring-halo" />
            <span className="incoming-ring-dot" />
          </span>
          <div className="incoming-label">Incoming call</div>
          <p className="incoming-caller">{caller}</p>
          <p className="incoming-tenant">{tenant}</p>
        </div>
        <div className="incoming-actions">
          <button className="incoming-btn decline" onClick={handleDecline}>Decline</button>
          <button className="incoming-btn accept" onClick={handleAccept}>Accept call</button>
        </div>
        {recentError && (
          <p className="incoming-softphone-error" role="alert">
            Softphone problem ({recentError.type}): {recentError.friendly}
          </p>
        )}
      </div>
    </main>
  );
}
